// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","264":"component---src-pages-work-md-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"99f4ae6b2128abc7d867","264":"4e6b62f6da0eaa00ef84","293":"36cf6c9f183e6c1115c3","454":"2535bac98602cee8d0c3"}[chunkId] + ".js";
};